"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNulls = void 0;
const removeNulls = (item) => {
    if (Array.isArray(item)) {
        return (item
            // eslint-disable-next-line no-null/no-null
            .filter((child) => child !== null)
            .map((child) => exports.removeNulls(child)));
        // eslint-disable-next-line no-null/no-null
    }
    else if (typeof item === "object" && item !== null) {
        const castItem = item;
        const keys = Object.keys(castItem);
        const result = {};
        keys
            // eslint-disable-next-line no-null/no-null
            .filter((key) => castItem[key] !== null)
            .forEach((key) => (result[key] = exports.removeNulls(castItem[key])));
        return result;
    }
    return item !== null && item !== void 0 ? item : undefined;
};
exports.removeNulls = removeNulls;
//# sourceMappingURL=remove_nulls.js.map